export enum SalesforceFieldType {
  DATE = 'date',
  DATETIME = 'datetime',
  BOOLEAN = 'boolean',
  DOUBLE = 'double',
  INTEGER = 'integer',
  CURRENCY = 'currency',
  REFERENCE = 'reference',
  STRING = 'string',
  PICKLIST = 'picklist',
  TEXTAREA = 'textarea',
  ADDRESS = 'address',
  PHONE = 'phone',
  URL = 'url',
  MULTIPICKLIST = 'multipicklist',
  PERCENT = 'percent',
  EMAIL = 'email',
  INT = 'int',
  LOCATION = 'location',
  ID = 'id',
  BASE64 = 'base64',
  ANYTYPE = 'anytype',
  TIME = 'time',
  ENCRYPTEDSTRING = 'encryptedstring',
  COMBOBOX = 'combobox',
}
